export interface DropzoneOptions {
  onText: (text: string) => void;
  onError: (message: string) => void;
}

const ACCEPTED_EXT = /\.(md|markdown)$/i;
const SIZE_WARN = 1_000_000; // 1 MB — warn but allow

function isAcceptable(file: File): boolean {
  if (ACCEPTED_EXT.test(file.name)) return true;
  if (file.type.startsWith('text/')) return true;
  return false;
}

export function attachDropzone(target: HTMLElement, options: DropzoneOptions): void {
  target.addEventListener('dragover', (ev) => {
    ev.preventDefault();
    target.classList.add('drop-active');
  });

  target.addEventListener('dragleave', () => {
    target.classList.remove('drop-active');
  });

  target.addEventListener('drop', async (ev) => {
    ev.preventDefault();
    target.classList.remove('drop-active');

    const file = ev.dataTransfer?.files?.[0];
    if (!file) return;

    if (!isAcceptable(file)) {
      options.onError("'.md' 또는 '.markdown' 파일만 지원합니다");
      return;
    }

    if (file.size > SIZE_WARN) {
      // emit warning first; still load — large docs are legitimate
      options.onError('파일이 1MB를 넘어 렌더링이 느릴 수 있습니다');
    }

    try {
      const text = await file.text();
      options.onText(text);
    } catch {
      options.onError('파일을 읽지 못했습니다');
    }
  });
}
